// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 首页
import LayoutTemplate from "@/views/Layout/template";
// import StudentsManage from "@/views/StudentsManage/StudentsManage";
// import TestManage from "@/views/TestManage/TestManage";
// import GradeManage from "@/views/GradeManage/GradeManage";
// import PaperManage from "@/views/PaperManage/PaperManage";
// import QuestionBank from "@/views/QuestionBank/QuestionBank";
// import QuestionRecycle from "@/views/QuestionBank/QuestionRecycle";
// import UserManage from "@/views/UserManage/UserManage";
import { Message } from "element-ui";
import { menuConfig } from "./menu.js";
// 启用路由
Vue.use(Router);

// 导出路由
const router = new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: LayoutTemplate,
      hidden: true,
      redirect: { path: "/question" },
      meta: {
        requireAuth: false
      },
      children: menuConfig
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    to.path !== "/login" &&
    (!localStorage.getItem("token") || !localStorage.getItem("zh_token"))
  ) {
    next({ path: "/login" });
    // Message({
    //   type: "error",
    //   message: "请先登录"
    // });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js